import {
    IconButton,
    Button,
    HStack,
    Icon,
    StackDivider,
    Text,
    Tooltip,
    VStack,
    Popover,
    PopoverCloseButton,
    PopoverHeader,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { DatabaseFilterViewProps } from '../../../../view';
import { ReportingViewBaseConfig } from '../../../../base';

export function createDatabaseFilterView(
    config: Omit<ReportingViewBaseConfig, 'Container'>
): React.FC<DatabaseFilterViewProps> {
    const {
        UI: {
            Application: { Link },
        },
    } = config;
    return (props) => {
        return (
            <Popover {...props.popover}>
                <PopoverTrigger>
                    <Button
                        size="sm"
                        iconSpacing={1}
                        flexShrink={0}
                        minH={7}
                        h={7}
                        px={3}
                        bg="none"
                        fontWeight="semibold"
                        color="whiteAlpha.600"
                        borderWidth={1}
                        borderColor="whiteAlpha.300"
                        borderRadius="full"
                        _hover={{
                            bg: 'whiteAlpha.100',
                        }}
                        rightIcon={<Icon as={ChevronDownIcon} />}
                    >
                        <Text>{props.property.label}</Text>
                    </Button>
                </PopoverTrigger>
                <PopoverContent>
                    <PopoverCloseButton />
                    <PopoverHeader>
                        <Text>{props.property.label}</Text>
                    </PopoverHeader>
                    <PopoverBody>
                        <VStack>
                            <Text>No input</Text>
                        </VStack>
                    </PopoverBody>
                </PopoverContent>
            </Popover>
        );
    };
}
